// only admin can delete / add staff
// only admin can edit staff details / other can edit their profile

// Define routes with lazy-loaded components
export const routes = [
    {
      path: '/',
      component: () => import('./components/LandingPage.vue')
    },
    {
      path: '/app',
      component: () => import('./components/LandingPage.vue')
    },
    {
      path: '/app/:app_slug/:lang?',
      component: () => import('./components/App.vue')
    },
    {
        path: '/app/:app_slug/category/:id/:lang?',
        name: 'category',
        component: () => import('./components/AppCategory.vue')
    },
    {
        path: '/app/:app_slug/article/:id/:lang?',
        name: 'article',
        component: () => import('./components/AppCatArticle.vue')
    },
    {
        path: '/app/:app_slug/search/:id/:lang?',
        name: 'search',
        component: () => import('./components/Search.vue')
    },
    {
        path: '/category/:id',
        component: () => import('./components/Category.vue')
    },
    {
        path: '/article/:id',
        component: () => import('./components/Article.vue')
    },
    {
        path: '/search/:id',
        component: () => import('./components/Search.vue')
    },
    {
        path: '/administrator/login',
        component: () => import('./components/auth/Login.vue'),
        meta: {
            title: 'Login'
        }
    },
    {
        path: '/administrator/forgot-password',
        component: () => import('./components/auth/Forgot.vue'),
        meta: {
            title: 'Forgot Password'
        }
    },
    {
        path: '/administrator/home',
        component: () => import('./components/admin/dashboard.vue'),
        meta: {
            requiresAuth: true
        },
        props: { default: true, header: 1 }
    },
    {
        path: '/administrator/',
        component: () => import('./components/admin/dashboard.vue'), 
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrator/articles',
        component: () => import('./components/admin/Articles.vue'), 
        meta: {
            requiresAuth: true
        }, props: { default: true, header: 2 }

    },
    {
        path: '/administrator/article/new',
        component: () => import('./components/admin/NewArticle.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrator/article/edit/:id',
        component: () => import('./components/admin/EditArticle.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrator/categories',
        component: () => import('./components/admin/Categories.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrator/categories/new',
        component: () => import('./components/admin/NewCategory.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrator/categories/edit/:id',
        component: () => import('./components/admin/EditCategory.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrator/staff',
        component: () => import('./components/admin/Staff.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrator/staff/new',
        component: () => import('./components/admin/NewStaff.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrator/staff/edit/:id',
        component: () => import('./components/admin/EditStaff.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrator/apps',
        component: () => import('./components/admin/Apps/Apps.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrator/app/new',
        component: () => import('./components/admin/Apps/NewApp.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrator/app/edit/:id',
        component: () => import('./components/admin/Apps/EditApp.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrator/search-terms',
        component: () => import('./components/admin/SearchTerms.vue'),
        meta: {
            requiresAuth: true
        }
    }
  ]
  
